import { createAction } from '@ngrx/store';

export const AppInit = createAction('[Root] APP_INIT');
export const AppReady = createAction('[Root] APP_READY');
